import { render, staticRenderFns } from "./GSTStat.vue?vue&type=template&id=113d8b7b&"
import script from "./GSTStat.vue?vue&type=script&lang=js&"
export * from "./GSTStat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports